import LocationsService from '../../services/LocationsService';
import ErrorHandlerHelpers from '../../mixins/ErrorHandlerHelpers';

const SET_LOCATIONS = 'SET_LOCATIONS';
const CLEAR_LOCATIONS = 'CLEAR_LOCATIONS';

const SET_LOCATION_TYPES = 'SET_LOCATION_TYPES';
const CLEAR_LOCATION_TYPES = 'CLEAR_LOCATION_TYPES';


const state = {
  locations: [],
  locationTypes: [],
};

const getters = {
  getLocations: (state) => state.locations,
  getPorts: (state) => state.locations.filter((location) => location.type === 'Port'),
};

const mutations = {
  [SET_LOCATIONS](state, locations) {
    state.locations = locations;
  },
  [CLEAR_LOCATIONS](state) {
    state.locations = [];
  },
  [SET_LOCATION_TYPES](state, types) {
    state.locationTypes = types;
  },
  [CLEAR_LOCATION_TYPES](state) {
    state.locationTypes = [];
  },
};

const actions = ({
  loadVesselLocations({ commit }, activeSiteId) {
    return LocationsService.getVesselLocations(activeSiteId)
      .then((x) => x.data.locations)
      .then((locations) => commit(SET_LOCATIONS, locations))
      .catch((err) => ErrorHandlerHelpers.handleServiceError(err));
  },
  loadLocationTypes({ commit }) {
    return LocationsService.getLocationTypes()
      .then((x) => x.data)
      .then((locationTypes) => commit(SET_LOCATION_TYPES, locationTypes))
      .catch(ErrorHandlerHelpers.handleServiceError);
  },
  createVesselLocation({ dispatch }, location) {
    return LocationsService.createLocation(location)
      .then((x) => x.data)
      .then((locationData) => {
        dispatch('loadVesselLocations', locationData.location.siteId);
      }).catch((err) => {
        ErrorHandlerHelpers.handleServiceError(err);
        return err;
      });
  },
  updateLocation({ dispatch }, locationUpdate) {
    return LocationsService.updateLocation(locationUpdate)
      .then((x) => x.data)
      .then((locationData) => {
        dispatch('loadVesselLocations', locationData.siteId);
      }).catch((err) => {
        ErrorHandlerHelpers.handleServiceError(err);
        return err;
      });
  },
  deleteLocation({ commit, dispatch, rootState }, id) {
    const activeSiteId = rootState.userStore.activeSite
      ? rootState.userStore.activeSite.id
      : rootState.userStore.user.activeSite.id;

    return LocationsService.deleteLocation(id)
      .then((x) => dispatch('loadVesselLocations', activeSiteId))
      .catch((err) => ErrorHandlerHelpers.handleServiceError(err));
  },
});

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
